import { Routes, Route, Navigate } from "react-router-dom";
import React, { Component } from "react";
import axios from "axios";
import {
  afterLoginpaths,
  authConfiguration,
} from "../components/custom/common";
import { PageNotFound } from "../components/custom/NotFoundPage";
import SideBar from "../components/pages/layout/SideBar";
import { ToastContainer } from "react-bootstrap";
import Users from "../components/pages/users/Users";
import Applications from "../components/pages/application/Application";
import { KeyCloackLoginClient } from "../components/custom/KeyCloackLoginClient";
import sideMenu from "../redux/SideBar/sideMenuAction";
import { connect } from "react-redux";
import withRouter from "../components/custom/withRouter";
import Settings from "../components/pages/setting/settings";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { UserNotFound } from "../components/pages/userNotFound";
import LogoutUser from "../components/pages/logoutUser";

import CreateAccount from "../components/pages/CreateAccount";
import CreateAccountContinue from "../components/pages/EmailVerification";
import Homepage from "../components/pages/Homepage";
import { Logoutcheck } from "../components/pages/logincheck";
import Setpassword from "../components/pages/Setpassword";
import Alreadyjoined from "../components/pages/Alreadyjoined";
import ProfileUI from "../components/pages/ProfileUI";
import Subscription from "../components/pages/Subscription/subscription";
import Group from "../components/pages/Group/Group";
import { Loader } from "../components/custom/CommonFunction";
import API from "../components/helpers/endpointservice";
import Unauthorize from "../components/pages/unauthorizeduser";
import Keyss from "../components/pages/key";

import Billpayments from "../components/pages/Bills/billpayments";
import Teamspage from "../components/pages/Teams/teams";

class Routing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      isMobContent: false,
      keyCloak: {},
      isAdmin: false,
      backdropvalue: false,
    };
    // this.firstFunction();
  }
  // firstFunction = () =>{
  //
  //   // this.props.dispatch({ type: "BG_LOADER", data: true })
  //   this.setState({backdropvalue:true})
  //   const token = localStorage.getItem('AccessToken');
  //   if(token){

  //   let headers={ 'Authorization': `Bearer ${token}` };

  //     axios.put(API.LAST_LOGIN,null,{headers}).then((res)=>
  //   {
  //     console.log(res);
  //     // this.props.dispatch({ type: "BG_LOADER", data: false })
  //     this.setState({backdropvalue:false})

  //   })
  //   .catch((er)=>{
  //
  //     console.log(er);
  //     // window.location.href='/login'
  //       this.setState({backdropvalue:false})
  //     this.props.handleLogout()
  //     // if(er.response.status==403){

  //     //
  //     //

  //     // }

  //   })
  // }
  //   // this.setState({backdropvalue:false})
  // }

  async componentDidMount () {
    const currentUrl = window.location.href;

    // Create a URL object from the current URL
    const url = new URL(currentUrl);
    const queryParams = new URLSearchParams(url.search);

    // Get specific parameter values
    const email = queryParams.get("email");
    const realm = queryParams.get("realm");

    console.log(email); // Output: "admin.user01@vikcc.com"
    console.log(realm); // Output: "vikcc"

    // Example of using the parameters in a useEffect hook
    // Replace with your logic
    if (email && realm) {
      // Perform actions based on email and realm values
      localStorage.setItem("userNameTAC", email);
      localStorage.setItem("realmNameTAC", realm);
    }
    const userDetails = localStorage.getItem("userDataTAC");
    let userToken = JSON.parse(userDetails);

    const userInfo = localStorage.getItem("UserInfoTAC");
    let useInforDetails = JSON.parse(userInfo);
    let final = useInforDetails?.userRole == "Admin" ? true : false;
    this.setState({ isAdmin: final });

    if (userToken) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${userToken.id_token}`;
    }
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  componentWillMount() {
    axios.interceptors.request.use(
      (config) => {
        const userDetails = localStorage.getItem("userDataTAC");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.id_token;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
      this.state.iswebMobile = false;
    } else {
      this.state.isMobile = false;
      this.state.iswebMobile = true;
    }

    if (window.innerWidth < 470) {
      this.state.isMobContent = true;
    } else {
      this.state.isMobContent = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };

  render() {
    const checkRoute = this.props.isLogin
      ? window.location.pathname.includes("users")
        ? false
        : !afterLoginpaths.includes(window.location.pathname)
      : this.props.isLogin === false && false;
    let { menuToggle } = this.props;
    const isSSOTAC = JSON.parse(localStorage.getItem("isSSOConfigTAC"));
    let mainClass =
      (this.state.iswebMobile && menuToggle) ||
      (this.state.isMobile && menuToggle)
        ? "main-content"
        : "main-content-expand";
    return (
      <>
        <Backdrop
          className="spinner-backdrop"
          open={
            this.props.isLoading || this.props.isLoader || this.props.BG_LOADER
          }
        >
          <CircularProgress color="primary" />
        </Backdrop>
        {checkRoute && <PageNotFound />}
        <div className={!checkRoute ? "container-width" : "d-none"}>
          {this.props.isLogin && !this.props.BG_LOADER && (
            <div>
              <SideBar handleLogout={this.props.handleLogout} />
            </div>
          )}
          <div
            className={`common-scroll ${mainClass} ${
              this.state.isMobContent ? "main-content-webmob" : ""
            }`}
          >
            <div className={`py-2 ${menuToggle ? "collapse-t" : "collapse-f"}`}>
              <ToastContainer />
              {this.props.isLogin ? (
                <Routes>
                  <>
                    <Route
                      path="/login"
                      element={
                        JSON.parse(localStorage.getItem("UserInfoTAC"))
                          ?.userRole === "Admin" ? (
                          <Navigate to={"/users"} />
                        ) : (
                          <Navigate to={"/homepage"} />
                        )
                      }
                    />
                    <Route path="/key" element={<Keyss />} />
                    <Route
                      path="/applications"
                      element={
                        <Applications handleLogout={this.props.handleLogout} />
                      }
                    />
                    <Route
                      path="/users"
                      element={
                        isSSOTAC ? (
                          <Navigate to="/subscription" replace />
                        ) : (
                          <Users handleLogout={this.props.handleLogout} />
                        )
                      }
                    />
                    {/* <Route path="/users" element={<Users handleLogout={this.props.handleLogout} />} /> */}
                    <Route
                      path="/settings"
                      element={
                        <Settings handleLogout={this.props.handleLogout} />
                      }
                    />
                    <Route
                      path="/logout"
                      element={
                        <LogoutUser handleLogout={this.props.handleLogout} />
                      }
                    />
                    <Route path="/homepage" element={<Homepage />} />
                    <Route
                      path="/profile"
                      element={
                        <ProfileUI handleLogout={this.props.handleLogout} />
                      }
                    />
                    <Route path="/logincheck" element={<Logoutcheck />} />
                    <Route path="/setpassword" element={<Setpassword />} />
                    <Route path="/subscription" element={<Subscription />} />
                    {/* <Route path="/groups" element={<Group />} /> */}
                    {/* <Route path="/teams" element={<Teamspage />} /> */}
                    {!isSSOTAC && (
                      <Route path="/teams" element={<Teamspage />} />
                    )}
                    <Route path="/billpayments" element={<Billpayments />} />
                    <Route
                      path="/unauthorize"
                      element={
                        <Unauthorize handleLogout={this.props.handleLogout} />
                      }
                    />
                  </>
                </Routes>
              ) : (
                <Routes>
                  {JSON.parse(
                    localStorage.getItem("realmNameTAC")?.length > 0
                  ) ? (
                    <></>
                  ) : (
                    <>
                      <Route
                        path="/*"
                        element={
                          localStorage.getItem("userNameTAC")?.length > 0 ? (
                            JSON.parse(localStorage.getItem("UserInfoTAC"))
                              ?.userRole === "Admin" ? (
                              <Navigate to={"/users"} />
                            ) : (
                              <Navigate to={"/homepage"} />
                            )
                          ) : (
                            <Navigate to={"/login"} />
                          )
                        }
                      />
                    </>
                  )}
                  <>
                    <Route
                      path="/"
                      element={
                        localStorage.getItem("userNameTAC")?.length > 0 ? (
                          JSON.parse(localStorage.getItem("UserInfoTAC"))
                            ?.userRole === "Admin" ? (
                            <Navigate to={"/users"} />
                          ) : (
                            <Navigate to={"/homepage"} />
                          )
                        ) : (
                          <Navigate to={"/login"} />
                        )
                      }
                    />
                    <Route
                      path="/login"
                      element={
                        <KeyCloackLoginClient
                          appName={authConfiguration?.appName}
                        />
                      }
                    />
                    <Route path="/usernotfound" element={<UserNotFound />} />
                    <Route
                      path="/logout"
                      element={
                        <LogoutUser handleLogout={this.props.handleLogout} />
                      }
                    />
                    <Route path="/createaccount" element={<CreateAccount />} />
                    <Route
                      path="/emailverification"
                      element={<CreateAccountContinue />}
                    />
                    <Route path="/logincheck" element={<Logoutcheck />} />
                    <Route path="/setpassword" element={<Setpassword />} />
                    <Route path="/alreadyjoined" element={<Alreadyjoined />} />
                    <Route
                      path="/unauthorize"
                      element={
                        <Unauthorize handleLogout={this.props.handleLogout} />
                      }
                    />
                  </>
                </Routes>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    sideMenu: () => dispatch(sideMenu()),
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.SideBarReducer.menuToggle,
    isLogin: state.loginReducer.isLogin,
    isLoader: state.commonReducer.isLoading,
    isLoader: state.commonReducer.isLoading,
    isRegisterLoad: state.commonReducer.isRegisterLoad,
    VerifyInviteFromLink: state.userReducer.VerifyInviteFromLink,
    BG_LOADER: state.userReducer.BG_LOADER,
    BG_HOME_LOADER: state.userReducer.BG_HOME_LOADER,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Routing)
);
